import interceptedAxios from '../../../utils/interceptedAxios'
import { type HistoryARDataObject, ZHistoryARApiResponse, ZHistoryDonutTableApiResponse, ZHistoryBubbleTableApiResponse, type HistoryDonutTableDataObject, type HistoryASDataObject, ZHistoryASApiResponse, type HistoryKSDataObject, ZHistoryKSApiResponse, type HistoryBubbleTableDataObject } from '../types'

export async function getHistoryARTable (
  kpiType: string,
  inputDateRead: string,
  page: number,
  size: number,
  service: string,
  unPaged: boolean,
  onSuccess: (dataObj: HistoryARDataObject, httpStatus: number) => any,
  onFailure: (error_message: string, httpStatus: number) => any
): Promise<void> {
  const url = `/${service}/api/v1/udp/liveData/${kpiType}?inputDateRead=${inputDateRead}&page=${page}&size=${size}&unPaged=${String(unPaged)}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZHistoryARApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        // istanbul ignore else
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        onFailure(error.response.data.error_message, error.response.data.http_status)
      } else {
        onFailure('Network Error', error.status)
      }
    })
}

export async function getHistoryKSTable (
  kpiType: string,
  inputDateRead: string,
  page: number,
  size: number,
  service: string,
  unPaged: boolean,
  onSuccess: (dataObj: HistoryKSDataObject, httpStatus: number) => any,
  onFailure: (error_message: string, httpStatus: number) => any
): Promise<void> {
  const url = `/${service}/api/v1/udp/liveData/${kpiType}?inputDateRead=${inputDateRead}&page=${page}&size=${size}&unPaged=${String(unPaged)}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZHistoryKSApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        onFailure(error.response.data.error_message, error.response.data.http_status)
      } else {
        onFailure('Network Error', error.status)
      }
    })
}

export async function getHistoryASTable (
  kpiType: string,
  inputDateRead: string,
  page: number,
  size: number,
  service: string,
  unPaged: boolean,
  onSuccess: (dataObj: HistoryASDataObject, httpStatus: number) => any,
  onFailure: (error_message: string, httpStatus: number) => any
): Promise<void> {
  const url = `/${service}/api/v1/udp/liveData/${kpiType}?inputDateRead=${inputDateRead}&page=${page}&size=${size}&unPaged=${String(unPaged)}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZHistoryASApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        // istanbul ignore else
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        onFailure(error.response.data.error_message, error.response.data.http_status)
      } else {
        onFailure('Network Error', error.status)
      }
    })
}

export async function getHistoryDonutTable (
  kpiType: string,
  inputDateRead: string,
  donutType: string,
  page: number,
  size: number,
  service: string,
  unPaged: boolean,
  onSuccess: (dataObj: HistoryDonutTableDataObject, httpStatus: number) => any,
  onFailure: (error_message: string, httpStatus: number) => any
): Promise<void> {
  let url = `/${service}/api/v1/udp/liveData/${kpiType}?barType=${donutType}&inputDateRead=${inputDateRead}&page=${page}&size=${size}&unPaged=${String(unPaged)}`
  if (kpiType === 'firmware-details') {
    url = `/${service}/api/v1/udp/liveData/${kpiType}?barType=${donutType}&page=${page}&size=${size}&unPaged=${String(unPaged)}`
  }

  console.log('url', url)

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZHistoryDonutTableApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        // istanbul ignore else
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        onFailure(error.response.data.error_message, error.response.data.http_status)
      } else {
        onFailure('Network Error', error.status)
      }
    })
}

export async function getHistoryBubbleTable (
  kpiType: string,
  inputDateRead: string,
  donutType: string,
  page: number,
  size: number,
  service: string,
  unPaged: boolean,
  onSuccess: (dataObj: HistoryBubbleTableDataObject, httpStatus: number) => any,
  onFailure: (error_message: string, httpStatus: number) => any
): Promise<void> {
  const url = `/${service}/api/v1/udp/liveData/${kpiType}?barType=${donutType}&inputDateRead=${inputDateRead}&page=${page}&size=${size}&unPaged=${String(unPaged)}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZHistoryBubbleTableApiResponse.safeParse(response.data)
      if (parseResponse.success) {
        // istanbul ignore else
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        onFailure(error.response.data.error_message, error.response.data.http_status)
      } else {
        onFailure('Network Error', error.status)
      }
    })
}
